import { sendMessageToCSharp } from "../../libs/kioskLib";
import { LabelsOnlyMeasurement } from "../../Types/Common/MeasurementTypes";
import { RESET_NIOX_FENO_STATE, SET_NIOX_FENO_CONNECTION_ATTEMPTS, SET_NIOX_FENO_CONNECTION_UNSTABLE, SET_NIOX_FENO_IPC_INITIALIZED, SET_NIOX_FENO_PAIRED_FENO_DEVICE_SERIAL_NUMBER, SET_NIOX_FENO_SIMULATE_CONNECTION, SET_NIOX_FENO_SIMULATE_MEASUREMENT, SET_NIOX_FENO_STATUS_REPORT, SET_NIOX_FENO_VIEW, SET_FENO_TYPE, SET_LANGUAGE_CODE, SET_FENO_TRANSLATIONS, SET_FENO_DEFAULT_TRANSLATIONS, SET_FENO_COLLECTIONID, SET_LABELS_MEASUREMENT, SET_FENO_VISIT_LABELS, SET_FENO_IQC_PERSIST_STATUS } from "./actionTypes";
import { NioxFenoActionType, NioxFenoState } from "./nioxFenoReducer";

export const setNioxFenoInitialized = (): NioxFenoActionType => ({
  payload: true,
  type: SET_NIOX_FENO_IPC_INITIALIZED
});

export const setNioxFenoView = (view: NioxFenoState['view']): NioxFenoActionType => ({
  payload: view,
  type: SET_NIOX_FENO_VIEW
});

export const setNioxFenoPairedFenoDeviceSerialNumber = (fenoDeviceSerialNumber: NioxFenoState['pairedFenoDeviceSerialNumber']): NioxFenoActionType => ({
  payload: fenoDeviceSerialNumber,
  type: SET_NIOX_FENO_PAIRED_FENO_DEVICE_SERIAL_NUMBER
});

export const setNioxFenoConnectionAttempts = (attempt: NioxFenoState['connectionAttempts']): NioxFenoActionType => ({
  payload: attempt,
  type: SET_NIOX_FENO_CONNECTION_ATTEMPTS
});

export const setNioxFenoStatusReport = (statusReport: NioxFenoState['statusReport']): NioxFenoActionType => ({
  payload: statusReport,
  type: SET_NIOX_FENO_STATUS_REPORT
});

export const setNioxFenoConnectionUnstable = (connectionUnstable: NioxFenoState['connectionUnstable']): NioxFenoActionType => ({
  payload: connectionUnstable,
  type: SET_NIOX_FENO_CONNECTION_UNSTABLE
});

export const setNioxFenoSimulateConnection = (simulateConnection: NioxFenoState['simulateConnection']): NioxFenoActionType => ({
  payload: simulateConnection,
  type: SET_NIOX_FENO_SIMULATE_CONNECTION
});

export const setNioxFenoSimulateMeasurement = (simulateMeasurement: NioxFenoState['simulateMeasurement']): NioxFenoActionType => ({
  payload: simulateMeasurement,
  type: SET_NIOX_FENO_SIMULATE_MEASUREMENT
});

export const resetNioxFenoState = (resetOverrides: Partial<NioxFenoState> = {}): NioxFenoActionType => {
  return {
    payload: resetOverrides,
    type: RESET_NIOX_FENO_STATE
  };
};

export const setFenoType = (fenoType: NioxFenoState['fenoType']): NioxFenoActionType => ({
  payload: fenoType,
  type: SET_FENO_TYPE
});

export const setLanguageCode = (languageCode: NioxFenoState['languageCode']): NioxFenoActionType => ({
  payload: languageCode,
  type: SET_LANGUAGE_CODE
});

export const setFenoTranslations = (translations: NioxFenoState['translations']): NioxFenoActionType => ({
  payload: translations,
  type: SET_FENO_TRANSLATIONS
});

export const setFenoDefaultTranslations = (defaultTranslations: NioxFenoState['defaultTranslations']): NioxFenoActionType => ({
  payload: defaultTranslations,
  type: SET_FENO_DEFAULT_TRANSLATIONS
});

export const setFenoCollectionID = (collectionID: NioxFenoState['collectionID']): NioxFenoActionType => ({
  payload: collectionID,
  type: SET_FENO_COLLECTIONID
})

export const setLabelsMeasurement = (labelsMeasurement: LabelsOnlyMeasurement): NioxFenoActionType => ({
  payload: labelsMeasurement,
  type: SET_LABELS_MEASUREMENT
});

export const setFenoVisitLabels = (labels: string[] | null): NioxFenoActionType => ({
  payload: labels,
  type: SET_FENO_VISIT_LABELS
});

export const setFenoIqcPersistStatus = (status: NioxFenoState['fenoIqcPersistStatus']): NioxFenoActionType => ({
  payload: status,
  type: SET_FENO_IQC_PERSIST_STATUS
});

export const killNioxFeno = (): NioxFenoActionType => {
  sendMessageToCSharp("NioxFenoKill", true);

  return resetNioxFenoState();
};
